import { render, staticRenderFns } from "./HistoryTakingKasemrad.vue?vue&type=template&id=5de5916a&scoped=true&"
import script from "./HistoryTakingKasemrad.vue?vue&type=script&lang=js&"
export * from "./HistoryTakingKasemrad.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTakingKasemrad.vue?vue&type=style&index=0&id=5de5916a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de5916a",
  null
  
)

export default component.exports